<template>
  <div class="news-container">
    <div class="header">
      <div class="title">
        <img src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x6.png" alt="">
        <span>学习<span class="highlight">资料</span></span>
        <div class="ll"></div>
        <span class="lll">LEARNING MATERIALS </span>
      </div>
      <div @click="goNext('/partnerPage/dataPackage')" class="more">
        查看更多 <img src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x7.png" alt="">
      </div>
    </div>
    <div class="card-container">
      <div @click="goPage(item)" class="card" v-for="(item, index) in items" :key="index">
        <div class="tag">学习资料</div>
        <div class="titles twoEllipsis">{{ item.title }}</div>
        <div class="price"><span>¥</span>{{ item.price }}</div>
      </div>
      <el-empty style="margin: 0 auto;" v-if="items.length == 0" description="暂无数据"></el-empty>

    </div>
  </div>
</template>

<script>
import { Know } from '@/api/know'
const know = new Know()
import { queryAllArticle } from "@/api/home";
import { DataClient } from '@/api/dataClient'
import { getInfo } from '@/api/cookies'
const dataClient = new DataClient()
export default {
  name: "NewsDynamic",
  data() {
    return {
      newsList: [

      ],
      items: [ 
      ],
      userInfo:''
    };
  },
 async created() {
    this.getList()
    this.userInfo = await getInfo()

  },
  methods: {
    async getList() {

      const res = await dataClient.getNewPackageList(
          5,
          1, 
        )
        this.items = res.rows
    },
        goPage(item) {
      if (this.userInfo) {
        this.$router.push({
          path: `/data/materialPage`,
          query: {
            id: item.id,
            title: item.title,
            schoolId: item.schoolId,
            isPurchase: item.isPurchase,
            num: item.price
          }
        })
      } else {
        this.$notify({
          title: '错误',
          message: '未登录，请去登录',
          type: 'error'
        })
      }
    },
  }

};
</script>

<style lang="scss" scoped>
.news-container {
  max-width: 1400px;
  margin: 0 auto;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  margin-top: 40px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.title {
  display: flex;
  align-items: center;

  font-family: DingTalk JinBuTi, DingTalk JinBuTi;
  font-weight: 400;
  font-size: 34px;

  img {
    width: 41px;
    margin-right: 9px;
  }

  .ll {
    margin: 0 17px;
    width: 0px;
    height: 28px;
    border-right: 1px solid #BBBBBB;
  }

  .lll {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 18px;
    color: #999999;
  }
}

.title .icon-news {
  width: 20px;
  height: 20px;
  background-color: #007bff;
  border-radius: 50%;
  margin-right: 8px;
}

.title .highlight {
  color: #007bff;
  margin-left: 4px;
}



.more {
  cursor: pointer;
  display: flex;
  align-items: center;

  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 18px;
  color: #666666;

  img {
    width: 31px;
    margin-left: 4px;
  }
}


.card-container {
  display: flex;
  justify-content: space-between;
 
  //background: #f5f5f5;
}

.card { 
  width: 265px;
  height: 169px;
  padding: 16px;
  background: url('https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x10.png');
  background-size: 100% 100%;
    

  .tag {
   width: 76px;
height: 32px;
background: #FFFFFF;
border-radius: 6px 6px 6px 6px;
 
font-family: PingFang SC, PingFang SC;
font-weight: 400;
font-size: 14px;
color: #AC6509;
line-height: 32px; 
text-align: center;
  }

  .titles {
  width: 231px;
height: 55px;
font-family: PingFang SC, PingFang SC;
font-weight: bold;
font-size: 18px;
color: #FFFFFF; 
margin-top: 10px;
  }

  .price {
    margin-top: 10px;
  
font-family: PingFang SC, PingFang SC;
font-weight: bold;
font-size: 20px;
color: #FB2D25; 
span{
font-size: 14px;
margin-right: 4px;

}
  }
}
.swImg{
  img{
    width: 100%;
  }

}
</style>